/*
 * @Author: JulyL
 * @Date: 2020-01-06 10:49:12
 * @Description: App 和 Web 进行通信的事件
 */
import './hcJsBridge';
const namespace = 'Elfinbook';
import { Toast, getLang } from './common';
import Ajax from './Ajax';
function call(event, data, fn) {
  // FIX: bug
  console.log('call event', event, data || 'nodata');
  try {
    if (data === undefined && fn === undefined) {
      window.hcJsBridge.callHandler(`${namespace}.${event}`);
    } else if ((data && !fn) || (data === undefined && fn)) {
      window.hcJsBridge.callHandler(`${namespace}.${event}`, data || fn);
    } else {
      window.hcJsBridge.callHandler(`${namespace}.${event}`, data, fn);
    }
  } catch (error) {
    console.log(error || 'error');
  }
}

function revertToJSON(r) {
  try {
    if (typeof r == 'string') {
      r = JSON.parse(r);
    }
  } catch (error) {}
  return r;
}

function request(reqConfig, fn) {
  let ajaxParams = {
    method: reqConfig.type
  };
  if (reqConfig.directRequest == true) {
    ajaxParams.url = reqConfig.method;
    // debugger;
    if (reqConfig.type == 'get') {
      ajaxParams.params = reqConfig.data;
    } else {
      ajaxParams.data = reqConfig.data;
    }
    return Ajax(ajaxParams).then((res) => {
      if (res.code == 0) {
        return res.data;
      } else if (res.code == 1000) {
        return res.data;
      } else {
        throw err;
      }
    });
  }
  // type: 1:get  2:post
  let opt = {
    type: reqConfig.type == 'get' ? '1' : '2',
    method: reqConfig.method
  };
  if (reqConfig.data) {
    // data中的每个值都转换为字符串
    let stringKeyData = {};
    for (let i in reqConfig.data) {
      let key = reqConfig.data[i];
      if (typeof key != 'object' && key != null) {
        stringKeyData[i] = String(key);
      } else {
        stringKeyData[i] = key;
      }
    }
    opt.data = stringKeyData;
  }
  return new Promise((resolve, reject) => {
    call('request', opt, (res) => {
      console.log('response', res || 'none');
      if (reqConfig.resolveData === false) {
        resolve(res);
      } else {
        if (res.code == 0) {
          resolve(res.data);
        } else if (res.code == 1000) {
          reject(res.data);
        } else {
          reject(res);
        }
      }
    });
  }).catch((err) => {
    if (['1005'].indexOf(String(err && err.code)) == -1) {
      let msg =
        err && typeof err == 'string' ? err : getLang('request_timeout');
      Toast(msg);
    }
    return err;
  });
}

function setTitle(title) {
  call('setTitle', title);
}

function back(data) {
  call('back', data);
}

function rate(data) {
  call('rate', data);
}

function uploadUserLog(data) {
  call('uploadUserLog', data);
}

function uploadBase64Photo(data) {
  return new Promise((resolve, reject) => {
    if (!data || data.length == 0) {
      resolve([]);
      return;
    }
    data = data.map((v, index) => {
      return v.replace('data:image/png;base64,', '');
    });
    call('uploadBase64Photo', data, (r) => {
      r = revertToJSON(r);
      resolve(r);
    });
  });
}

function verifyUser(data) {
  return new Promise((resolve, reject) => {
    call('verifyCancelAccount', data, (r) => {
      // 1:登录 0：未登录
      if (r == 1) {
        resolve();
      } else {
        reject();
      }
    });
  });
}

function uploadAlbumMedia(data) {
  return new Promise((resolve, reject) => {
    call('uploadAlbumMedia', data, (r) => {
      r = revertToJSON(r);
      resolve(r);
    });
  });
}

function getAlbumPhoto(data) {
  return new Promise((resolve, reject) => {
    call('getAlbumPhoto', data, (r) => {
      r = revertToJSON(r);
      resolve(r);
    });
  });
}

function checkLogin(data) {
  return new Promise((resolve, reject) => {
    call('checkLogin', data, (r) => {
      // console.log('checkLogin', r);
      // 1:登录 0：未登录
      if (r == 1) {
        resolve();
      } else {
        reject();
      }
    });
  });
}

function getUserInfo(data) {
  return new Promise((resolve, reject) => {
    call('getUserInfo', data, (r) => {
      resolve(r);
    });
  });
}

function shareWebUrl(data) {
  return new Promise((resolve, reject) => {
    call('shareWebUrl', data, (r) => {
      resolve(r);
    });
  });
}

function premium(data) {
  return new Promise((resolve, reject) => {
    call('premium', data, (r) => {
      resolve(r);
    });
  });
}
function invitePrize(data) {
  return new Promise((resolve, reject) => {
    call('invitePrize', data, (r) => {
      resolve(r);
    });
  });
}

function addStickerCol(data) {
  return new Promise((resolve, reject) => {
    call('addStickerCol', data, (r) => {
      r = revertToJSON(r);
      resolve(r);
    });
  });
}

function showStickerCol(data) {
  call('showStickerCol', data);
}

export {
  call,
  request,
  setTitle,
  checkLogin,
  verifyUser,
  uploadAlbumMedia,
  back,
  getAlbumPhoto,
  rate,
  uploadUserLog,
  uploadBase64Photo,
  getUserInfo,
  shareWebUrl,
  invitePrize,
  premium,
  addStickerCol,
  showStickerCol
};
